/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusetitle2Inputs */

const id_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Penggunaan Wajar`)
};

const ms_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasar Penggunaan Adil`)
};

const da_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Politik`)
};

const de_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair-Use-Richtlinie`)
};

const en_us2_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use Policy`)
};

const es_es2_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo`)
};

const es_mx2_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo`)
};

const fil_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patakaran sa Patas na Paggamit`)
};

const fr_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique d'utilisation équitable`)
};

const it_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica di fair use`)
};

const hu_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use irányelv`)
};

const nl_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair Use-beleid`)
};

const no_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retningslinjer for rimelig bruk`)
};

const pl_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polityka dozwolonego użytku`)
};

const pt_br2_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de uso justo`)
};

const pt_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Uso Justo`)
};

const ro_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica de utilizare corectă`)
};

const fi_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohtuullisen käytön käytäntö`)
};

const sv_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Policy för skälig användning`)
};

const vi_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chính sách sử dụng hợp lý`)
};

const tr_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adil Kullanım Politikası`)
};

const cs_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zásady spravedlivého použití`)
};

const bg_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика за честна употреба`)
};

const ru_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика добросовестного использования`)
};

const uk_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Політика добросовісного використання`)
};

const ar_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الاستخدام العادل`)
};

const hi_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उचित उपयोग नीति`)
};

const th_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายการใช้งานโดยชอบ`)
};

const ja_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フェアユースポリシー`)
};

const zh_cn2_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合理使用政策`)
};

const zh_hant1_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合理使用政策`)
};

const ko_about_fairusetitle2 = /** @type {(inputs: About_Fairusetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공정 사용 정책`)
};

/**
* | output |
* | --- |
* | "Fair Use Policy" |
*
* @param {About_Fairusetitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusetitle2 = /** @type {((inputs?: About_Fairusetitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusetitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusetitle2(inputs)
	if (locale === "ms") return ms_about_fairusetitle2(inputs)
	if (locale === "da") return da_about_fairusetitle2(inputs)
	if (locale === "de") return de_about_fairusetitle2(inputs)
	if (locale === "en-US") return en_us2_about_fairusetitle2(inputs)
	if (locale === "es-ES") return es_es2_about_fairusetitle2(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusetitle2(inputs)
	if (locale === "fil") return fil_about_fairusetitle2(inputs)
	if (locale === "fr") return fr_about_fairusetitle2(inputs)
	if (locale === "it") return it_about_fairusetitle2(inputs)
	if (locale === "hu") return hu_about_fairusetitle2(inputs)
	if (locale === "nl") return nl_about_fairusetitle2(inputs)
	if (locale === "no") return no_about_fairusetitle2(inputs)
	if (locale === "pl") return pl_about_fairusetitle2(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusetitle2(inputs)
	if (locale === "pt") return pt_about_fairusetitle2(inputs)
	if (locale === "ro") return ro_about_fairusetitle2(inputs)
	if (locale === "fi") return fi_about_fairusetitle2(inputs)
	if (locale === "sv") return sv_about_fairusetitle2(inputs)
	if (locale === "vi") return vi_about_fairusetitle2(inputs)
	if (locale === "tr") return tr_about_fairusetitle2(inputs)
	if (locale === "cs") return cs_about_fairusetitle2(inputs)
	if (locale === "bg") return bg_about_fairusetitle2(inputs)
	if (locale === "ru") return ru_about_fairusetitle2(inputs)
	if (locale === "uk") return uk_about_fairusetitle2(inputs)
	if (locale === "ar") return ar_about_fairusetitle2(inputs)
	if (locale === "hi") return hi_about_fairusetitle2(inputs)
	if (locale === "th") return th_about_fairusetitle2(inputs)
	if (locale === "ja") return ja_about_fairusetitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusetitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusetitle2(inputs)
	return ko_about_fairusetitle2(inputs)
});
export { about_fairusetitle2 as "about.fairUseTitle" }